import React from "react";
import GameRoom from "./screens/GameRoom";
import Home from "./screens/Home";
import { Router } from "@reach/router";
import SignUp from "./screens/SignUp";
import SignIn from "./screens/SignIn";
import TestGrid from "./screens/TestGrid";

function App() {
  return (
    <Router>
      <Home path="/" />
      <SignUp path="/sign-up" />
      <SignIn path="/sign-in" />
      <GameRoom path="/:roomId" />
      <TestGrid path="/__test-grid" />
    </Router>
  );
}

export default App;
